import { render } from "./GerenciamentoParametros.vue?vue&type=template&id=22179d07&scoped=true"
import script from "./GerenciamentoParametros.vue?vue&type=script&lang=js"
export * from "./GerenciamentoParametros.vue?vue&type=script&lang=js"

import "./GerenciamentoParametros.vue?vue&type=style&index=0&id=22179d07&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22179d07"]])

export default __exports__